export enum CallStatusEnum {
  New = 'new',
  InProgress = 'in progress',
  CallStarted = 'call started',
  CallCompleted = 'call completed',
  Completed = 'completed',
  Abandoned = 'abandoned',
  Cancelled = 'canceled',
}
